import React from 'react'
import './style/AfterHeader.css'
import photo from '../imgs/Sans-titre2.png'
import Button from './buttons/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF } from '@fortawesome/free-brands-svg-icons'
import { faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'


function AfterHeader() {
    return (
        <div className="afterHeader">
            <div className="hello">
                <span>Hello I'm</span>
                <h1>Johthan Smith</h1>
                <h4>Professional Freelancer & Web Developer</h4>
                <div>Ad occaecat duis occaecat nulla cillum reprehenderit do voluptate est Lorem. Consequat do pariatur non eiusmod ea id ullamco laborum labore in minim sint officia.</div>
                <Button text="Hire Me"/>
                <div className="socialIcon">
                    <FontAwesomeIcon icon={faFacebookF} />
                    <FontAwesomeIcon icon={faTwitter} />
                    <FontAwesomeIcon icon={faInstagram} />
                    <FontAwesomeIcon icon={faLinkedinIn} />
                </div>
            </div>
            <div className="photo">
                <img src={photo} alt="it's me" />
            </div>


        </div>
    )
}

export default AfterHeader
